module.exports = __webpack_public_path__ + "media/images/enterprise-type-f410335b1c4248acbd9b1167e5745e22.png";